const zh = {
  services: {
    seoTitle: "服务 · 马托雷利 Hotel Ciutat Martorell",
    seoDesc: "酒店与客房的全部服务：商务角、My Bar 餐厅、停车场、健身房、免费 WiFi、24 小时前台等。",
    eyebrow: "服务",
    title: "舒适入住所需的一切",
    hotelTitle: "酒店服务",
    hotel: [
      "空调与暖气",
      "电梯",
      "每日自助早餐",
      "商务角（Business Corner）",
      "行李寄存",
      "健身房",
      "视听设备",
      "停车场",
      "24 小时前台",
      "My Bar 餐厅，每日供应午餐与晚餐",
      "24 小时客房服务",
      "会议与宴会厅",
      "洗衣 / 干洗服务",
      "打印服务",
      "免费 WiFi",
    ],
    roomsTitle: "客房内",
    rooms: [
      "适合行动不便的客人",
      "独立空调与暖气",
      "浴室洗浴用品",
      "配备淋浴或浴缸及／或坐浴盆的完整浴室",
      "书桌",
      "迷你吧",
      "吹风机",
      "平板电视，带 USB 接口",
      "客房与浴室内电话",
      "免费 WiFi",
      "可提供婴儿床",
      "加床",
      "无烟客房",
    ],
    fitness: {
      eyebrow: "健身",
      title: "健身房",
      text: "入住期间也能保持锻炼习惯，我们的健身房配备跑步机、健身单车与哑铃。",
      alts: ["健身房，配健身单车、跑步机与毛巾", "健身房，配跑步机、单车与镜前哑铃"],
    },
    shop: {
      eyebrow: "官方商品",
      title: "足球的热情，就在前台",
      text: "在我们的前台，您可以找到巴塞罗那足球俱乐部和皇家马德里的官方商品。把您球队的热情带回家。",
      note: "仅在前台销售",
      cta: "请到前台咨询",
      clubs: [
        { name: "巴塞罗那", items: "球衣、帽子、围巾、背包、足球等等。" },
        { name: "皇家马德里", items: "球衣、队服、帽子、足球、围巾等等。" },
      ],
    },
  },
  nav: {
    nye: "2026 跨年夜",
    hotel: "酒店",
    rooms: "客房",
    services: "服务",
    corporate: "企业与会议",
    events: "活动与婚礼",
    restaurant: "餐厅",
    location: "位置",
    biosphere: "可持续发展",
    gallery: "图库",
    blog: "博客",
    contact: "联系",
    book: "直接预订",
    menu: "菜单",
    close: "关闭",
    call: "致电",
    map: "地图",
    bookShort: "预订",
  },
  hero: {
    availability: "查询房态",
    checkin: "入住",
    checkout: "退房",
    adults: "成人",
    children: "儿童",
    promo: "优惠码",
    promoPlaceholder: "可选",
    bestPrice: "在此预订享最优价格保证",
    scroll: "向下滚动",
  },
  attrs: [
    { t: "最优价格保证", d: "直接预订时" },
    { t: "灵活取消", d: "视房价而定" },
    { t: "自助早餐", d: "06:30–10:30" },
    { t: "私人停车场", d: "需额外收费，视供应情况而定" },
    { t: "距 Renfe 与 FGC 100 米", d: "距巴塞罗那 30 分钟" },
  ],
  marquee: ["马托雷利", "距巴塞罗那 30 分钟", "蒙特塞拉特", "Renfe 与 FGC 仅 100 米", "SEAT-CUPRA 商务区", "四星舒适", "92 间客房", "直接预订"],
  home: {
    presEyebrow: "酒店",
    stats: [
      { n: "92", l: "间标准客房" },
      { n: "100 米", l: "距 Renfe 与 FGC" },
      { n: "30 分钟", l: "距巴塞罗那与机场" },
      { n: "180", l: "人可容纳于主宴会厅" },
    ],
    roomsEyebrow: "客房",
    roomsTitle: "量身定制的休憩",
    roomsText: "两种房型，专为商务旅客、家庭及长期入住而设计。",
    roomsCta: "查看全部客房",
    from: "起价",
    detail: "查看详情",
    corpEyebrow: "企业与会议",
    corpTitle: "商务枢纽|距 SEAT-CUPRA 仅 5 分钟",
    corpFeatures: ["3 间会议室", "最多可容纳 180 人", "WiFi 连接与视听设备", "茶歇与商务午餐"],
    corpCta: "索取报价",
    corpSecondary: "查看会议室",
    restEyebrow: "美食",
    restCta: "探索餐厅",
    locEyebrow: "位置",
    locCta: "如何抵达",
    galleryEyebrow: "图库",
    galleryCta: "查看完整图库",
    directEyebrow: "直接预订",
    directTitle: "在此预订总是更划算",
    directItems: [
      { t: "最优线上价格", d: "没有任何代理商能提供比我们官网更低的价格。" },
      { t: "灵活条款", d: "可免费取消，到店付款的房价。" },
      { t: "直接沟通", d: "入住前后您都直接与酒店团队沟通，没有中间商。" },
      { t: "欢迎礼遇", d: "延迟退房视供应情况而定，直接预订客人享专属礼遇。" },
    ],
    testimonialsEyebrow: "评价",
    testimonials: [
      { q: "在工业区工作的绝佳位置。客房安静、早餐丰盛。我们每月都会再来。", a: "Marc V.", r: "商务出行" },
      { q: "我们在宴会厅为女儿举办了圣餐礼，一切都无可挑剔。团队照顾到了每一个细节。", a: "Laura & Jordi", r: "家庭庆典" },
      { q: "步行 2 分钟即到火车站，半小时到巴塞罗那。是游览城市与蒙特塞拉特的宁静而精心打理的据点。", a: "Claire D.", r: "短途度假" },
    ],
    contactEyebrow: "与我们交流",
    contactCta: "联系我们",
    rfpCta: "索取报价",
  },
  rooms: {
    eyebrow: "客房",
    surface: "面积",
    occupancy: "可住人数",
    bed: "床型",
    bath: "浴室",
    features: "设施",
    guests: "人",
    book: "预订此客房",
    all: "全部客房",
    photosEyebrow: "图库",
    photosTitle: "客房与浴室",
    photosCount: "张照片",
    featureLabels: {
      wifi: "高速 Wi-Fi",
      ac: "空调",
      tv: "电视",
      desk: "办公桌",
      minibar: "迷你吧",
      hairdryer: "吹风机",
      crib: "可提供婴儿床",
      extra_bed: "加床",
      accessible: "无障碍",
      nonsmoking: "无烟",
    },
    servicesEyebrow: "服务",
    family: {
      eyebrow: "带家人出行",
      title: "家庭选项",
      beds: { t: "加床（三人间）", d: "加一张床即可将客房变为三人间。12 岁以下儿童免费。" },
      crib: { t: "免费婴儿床", d: "为小宝宝免费提供婴儿床。" },
      note: "两项均视供应情况而定；请在预订时提前申请。",
    },
    servicesTitle: "您需要的一切，我们都已备齐",
    services: [
      { t: "自助早餐", d: "每日供应本地食材、手工糕点与健康选择。" },
      { t: "私人停车场", d: "需额外付费，视供应情况而定。" },
      { t: "光纤 Wi-Fi", d: "全酒店对称网络连接，无需额外付费。" },
      { t: "24 小时前台", d: "团队随时待命，满足您的任何需求。" },
      { t: "健身房", d: "入住期间也能保持您的健身习惯。" },
      { t: "餐厅与酒吧", d: "商务套餐、地中海菜单与悠闲小酌。" },
    ],
    notFound: "未找到该客房",
  },
  corporate: {
    eyebrow: "企业",
    title: "您在略夫雷加特工业走廊的运营基地",
    pillars: [
      { t: "企业协议价", d: "为频繁入住并集中结算的企业提供协商价格。" },
      { t: "会议室", d: "三个可灵活分隔的空间，容纳 12 至 180 人。" },
      { t: "工作与休息", d: "每间客房配备办公桌、Wi-Fi 及清晨早餐。" },
      { t: "商务餐饮", d: "酒店内即可享用茶歇、工作午餐与团队晚宴。" },
    ],
    salasEyebrow: "会议室",
    photosTitle: "会议室与活动",
    salasTitle: "随您日程灵活调整的空间",
    salasCta: "查看全部会议室与容量",
    formEyebrow: "企业价格",
    formTitle: "索取您的企业协议价",
    formText: "告诉我们您的团队每年需要多少晚住宿，我们将在 24 小时内为您准备方案。",
    capacityTitle: "各布置方式容量",
    capacityLabels: { teatro: "剧院式", escuela: "课桌式", u: "U 型", imperial: "口字型", coctel: "酒会式", banquete: "宴会式" },
    equipmentLabels: {
      wifi: "光纤 Wi-Fi", proyector: "投影仪与幕布", flipchart: "挂纸白板", pizarra: "白板",
      coffee_break: "茶歇", agua: "矿泉水", escritura: "文具", luz_natural: "自然采光", panelable: "可分隔",
    },
    area: "面积",
    people: "人",
    upTo: "最多",
    requestRoom: "索取此会议室报价",
    salasIntro: "所有会议室均配备光纤 Wi-Fi、独立空调、视听设备及茶歇服务。我们将协助您选择理想的布置方式。",
    servicesTitle: "为您的活动提供的服务",
    services: ["欢迎及上午茶歇", "商务午餐或工作自助餐", "为演讲嘉宾与参会者提供住宿", "为参会者提供停车位", "活动期间的技术支持", "秘书服务与文具"],
    otherRooms: "其他会议室",
    notFound: "未找到该会议室",
  },
  events: {
    eyebrow: "活动与庆典",
    title: "重要的日子值得一个相称的场所",
    intro: "婚礼、圣餐礼、周年庆与团体聚会，尽在 220 平方米、自然采光、配备自有厨房的宴会厅，并有 92 间客房让宾客无需驾车返程。",
    types: [
      { key: "weddings", t: "婚礼", d: "最多可容纳 150 位宾客的宴会、欢迎酒会及免费婚房。", cta: "探索婚礼" },
      { key: "celebrations", t: "庆典", d: "圣餐礼、洗礼、生日与周年庆，为各年龄段量身定制菜单。", cta: "查看庆典" },
      { key: "groups", t: "团体", d: "运动队、组团旅行及蒙特塞拉特朝圣者享特别优惠。", cta: "团体与旅行" },
    ],
    stepsEyebrow: "我们的流程",
    steps: [
      { t: "初次沟通", d: "参观酒店，聆听您的想法，并推荐场地与菜单。" },
      { t: "量身定制方案", d: "48 小时内提供固定报价，绝无意外，婚礼可预先试菜。" },
      { t: "重要的一天", d: "专属协调员负责时间安排与供应商，让您只需尽情享受。" },
    ],
    formEyebrow: "告诉我们您的活动",
    formTitle: "让我们开始筹划",
    weddings: {
      title: "在马托雷利举办婚礼，距巴塞罗那半小时",
      intro: "可分隔、自然采光的宴会厅用于婚宴，露台用于酒会，客房供新人及宾客使用。自有地中海厨房，专属协调员从第一杯咖啡陪伴至最后一支舞。",
      includes: ["欢迎酒会", "含预先试菜的宴会", "免费婚房", "宾客专属优惠价", "可选开放式酒吧与 DJ"],
    },
    celebrations: {
      title: "圣餐礼、洗礼与周年庆",
      intro: "家庭庆典，菜单兼顾长者与孩童，设有儿童娱乐空间，一切尽在同一屋檐下，让您安心。",
      includes: ["儿童与成人菜单", "娱乐活动空间", "量身定制装饰", "个性化蛋糕", "拍照区", "供亲属入住的客房"],
    },
    groups: {
      title: "团体、队伍与组团旅行",
      intro: "为 10 至 180 人的团体提供住宿，含提前早餐、团体晚宴及快速入住。前往蒙特塞拉特与巴塞罗那的理想起点。",
      includes: ["10 间客房起的团体价", "可应需求提前供应早餐", "团体晚宴与野餐", "团体集体入住"],
    },
    includesTitle: "方案包含内容",
    back: "全部活动",
  },
  restaurant: {
    eyebrow: "My Bar",
    title: "地中海时令市集料理",
    hoursTitle: "营业时间",
    breakfast: "早餐",
    lunch: "午餐",
    dinner: "晚餐",
    menuEyebrow: "菜单",
    menus: [
      { t: "自助早餐", d: "手工糕点、新鲜水果、加泰罗尼亚冷切肉、现做鸡蛋与精品咖啡。", p: "06:30 – 10:30" },
      { t: "商务套餐", d: "周一至周五午餐供应。三道时令菜品，含面包、饮品与咖啡。", p: "价格请咨询" },
      { t: "地中海菜单", d: "米饭料理、当日鲜鱼、炭烤肉类与自制甜点，佩内德斯葡萄酒佐餐。", p: "晚餐及周末" },
      { t: "团体套餐", d: "为企业、庆典及旅行团提供固定方案，10 位用餐者起订。", p: "量身定制" },
    ],
    reserveTitle: "预订餐桌",
    reserveText: "致电我们，即刻为您确认餐桌。",
    reserveCta: "致电餐厅",
    reserveTap: "点击拨打",
    wineEyebrow: "酒窖",
    wineTitle: "佩内德斯及全加泰罗尼亚葡萄酒",
    wineText: "一份简短而诚挚的酒单，优先选用本地小型酒庄：卡瓦气泡酒、沙雷洛与歌海娜，佐配时令料理。",
  },
  location: {
    eyebrow: "位置与交通",
    title: "位于一切要事的中心",
    pois: [
      { name: "Renfe / FGC Martorell Enllaç 车站", dist: "100 米", time: "步行 2 分钟", mode: "walk" },
      { name: "SEAT-CUPRA 总部与工业园区", dist: "2.5 公里", time: "驾车 5 分钟", mode: "car" },
      { name: "蒙特塞拉特修道院与自然公园", dist: "19 公里", time: "驾车 20 分钟 / 齿轨列车", mode: "car" },
      { name: "巴塞罗那市中心（西班牙广场 / 加泰罗尼亚广场）", dist: "28 公里", time: "直达火车或 A-2 公路 30 分钟", mode: "train" },
      { name: "巴塞罗那-埃尔普拉特机场 (BCN)", dist: "32 公里", time: "高速公路 25 分钟", mode: "plane" },
      { name: "加泰罗尼亚-巴塞罗那赛道", dist: "45 公里", time: "经 AP-7 公路 40 分钟", mode: "car" },
    ],
    faqEyebrow: "常见问题",
    faqTitle: "如何抵达与出行",
    mapCta: "在 Google 地图中打开",
    appleCta: "在 Apple 地图中打开",
    addressTitle: "地址",
    transportTitle: "交通",
    transportItems: [
      { t: "乘火车", d: "Renfe R4 与 FGC（Martorell Enllaç / Martorell Central）仅 100 米。30 分钟到巴塞罗那。" },
      { t: "自驾", d: "A-2（585 Martorell 出口）与 AP-7（25 Martorell 出口）公路直接出口。" },
      { t: "从机场出发", d: "高速公路 25 分钟。建议乘坐出租车或租车。" },
    ],
  },
  gallery: {
    eyebrow: "图库",
    title: "影像中的酒店",
    all: "全部",
    cats: { habitaciones: "客房", restaurante: "餐厅", salas: "会议室", eventos: "活动", fitness: "健身房", comunes: "公共区域" },
  },
  blog: {
    eyebrow: "博客与指南",
    title: "从容漫游马托雷利、巴塞罗那与蒙特塞拉特",
    read: "分钟阅读",
    readMore: "阅读文章",
    back: "返回博客",
    related: "相关文章",
    notFound: "未找到文章",
  },
  contact: {
    eyebrow: "联系",
    title: "来聊聊您的入住或活动",
    text: "我们将在 24 个工作小时内回复。客房预订请使用我们的直接预订系统，享最优价格保证。",
    phone: "电话",
    email: "电子邮箱",
    address: "地址",
    hours: "24 小时前台",
    formEyebrow: "表单",
    formTitle: "我们能为您做些什么？",
  },
  form: {
    type: "需求类型",
    types: { contacto: "一般咨询", empresa: "企业协议价", salas: "会议室 / 会议报价", evento: "婚礼 / 庆典 / 团体", restaurante: "餐厅预订" },
    name: "姓名",
    company: "公司 / 组织",
    email: "电子邮箱",
    phone: "电话",
    nights: "每年住宿晚数（约）",
    guests: "人数 / 用餐人数",
    date: "预计日期",
    attendees: "参加人数",
    eventType: "活动类型",
    eventTypes: ["婚礼", "圣餐礼 / 洗礼", "周年庆 / 生日", "会议 / 培训", "大型会议", "旅行团体", "其他"],
    setup: "偏好布置方式",
    setups: ["剧院式", "课桌式", "U 型", "口字型", "酒会式", "宴会式"],
    catering: "餐饮",
    caterings: ["茶歇", "商务午餐", "晚餐", "不需餐饮"],
    lodging: "您需要住宿吗？",
    lodgings: ["需要", "不需要", "待确认"],
    message: "备注",
    messagePlaceholder: "告诉我们您的需求…",
    consent: "我已阅读并接受隐私政策以及为处理此请求而处理我的数据。",
    submit: "提交请求",
    sending: "发送中…",
    success: "请求已发送。我们将在 24 小时内回复。",
    error: "发送失败。请重试或致电我们。",
    required: "必填项",
    invalidEmail: "电子邮箱无效",
    consentRequired: "您必须接受隐私政策",
    select: "选择",
  },
  footer: {
    tagline: "位于马托雷利的四星酒店。距巴塞罗那 30 分钟，休憩、工作与庆典之所。",
    explore: "探索",
    business: "企业",
    guides: "指南",
    legal: "法律",
    contact: "联系",
    legalNotice: "法律声明",
    privacy: "隐私",
    cookies: "Cookie",
    cookieSettings: "Cookie 设置",
    rights: "版权所有。",
    registration: "旅游登记",
    newsletter: "接收专属优惠",
    newsletterText: "只有值得分享的内容，我们才会来信。",
    subscribe: "订阅",
    subscribed: "感谢您，我们会随时与您保持联系。",
    directBook: "直接预订 · 最优价格保证",
  },
  legal: {
    legal: { title: "法律声明", date: "2026年10月", sections: [
      ["身份识别信息", "根据 2002 年 7 月 11 日关于信息社会服务与电子商务的第 34/2002 号法律（LSSI-CE）的规定，现公布以下信息：\n所有者：EYE STAR, S.L.\n商号：Hotel Ciutat Martorell\n税号（NIF）：B87171740\n注册地址：Avda. de la Industria, 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)，西班牙\n营业场所地址：Avda. Pau Claris, s/n, 08760 Martorell (Barcelona)，西班牙\n电话：+34 937 745 160\n电子邮箱：info@hotel-martorell.com\n网站：www.hotel-martorell.com\n登记信息：马德里商业登记处，第 32963 卷，第 138 页，表 M-593334，第 1 次登记。"],
      ["目的", "本法律声明规范网站 www.hotel-martorell.com 的访问、浏览与使用，以及因使用其内容及（如适用）通过其提供的服务所产生的责任。\n访问与浏览本网站即赋予用户身份，并意味着接受本法律声明所载的条件。"],
      ["使用条件", "用户承诺依据现行法律、诚信原则、公共秩序及本法律声明使用本网站。\n用户不得将本网站用于非法目的或违反本法律声明规定的目的，亦不得实施任何可能损害、使之无法使用、使之超载或使之劣化的行为，无论针对网站本身、其内容，还是支撑网站的系统与设备。"],
      ["知识产权与工业产权", "本网站的全部内容，包括但不限于文本、照片、图像、图形、标志、图标、设计、结构、源代码及构成本网站的其他要素，均归 EYE STAR, S.L. 所有，或经其合法权利人相应授权使用。\n上述内容受现行知识产权与工业产权法规的保护。\n未经 EYE STAR, S.L. 事先明确授权，禁止对本网站内容进行全部或部分的复制、分发、公开传播、转换或任何其他形式的利用，法律允许的情形除外。"],
      ["责任", "EYE STAR, S.L. 将力求使本网站内容正确且保持更新。但其不保证不存在错误或遗漏，对于因其无法控制的情形而导致、因使用本网站所含信息而可能产生的损害或损失，不承担责任。\nEYE STAR, S.L. 亦不保证本网站运行的可用性与连续性，可能因技术、维护原因或其无法控制的情形而发生中断。\n本网站可能包含指向第三方网站的链接。EYE STAR, S.L. 对该等外部网站的内容、服务、运行或隐私政策不承担任何责任。"],
      ["个人数据保护", "通过本网站可能收集的个人数据，其处理将依据现行个人数据保护法规进行。\n有关数据负责人、处理目的、法律依据、接收方、保存期限以及用户可行使的权利的信息，可在本网站的隐私政策中查阅。"],
      ["Cookie", "本网站可能使用 Cookie 及类似技术。\n有关所用 Cookie、其目的、可能介入的第三方以及用户如何管理其偏好的信息，可在 Cookie 政策中查阅。\n非严格必要的 Cookie 将依据适用法规使用，并在必要时事先取得用户的同意。"],
      ["商业信息", "当用户已就通过电子方式接收商业信息作出同意时，该等信息将依据现行法律发送。\n用户可随时通过每则信息中为此设置的机制，反对接收商业信息。"],
      ["修改", "EYE STAR, S.L. 保留随时且无需事先通知即可修改、更新或删除通过本网站提供的内容与服务以及本法律声明的权利。\n修改自其在本网站公布之时起适用。"],
      ["适用法律与管辖", "EYE STAR, S.L. 与用户之间的关系受西班牙法律管辖。\n就与访问或使用本网站相关的任何争议的解决，依据适用法规确定有管辖权的法院与法庭。\n当用户具有消费者身份时，将遵守适用的关于司法管辖与消费者保护的强制性规定。"],
    ]},
    privacy: { title: "隐私政策", date: "2025年7月18日", sections: [
      ["数据负责人", "公司名称：EYE STAR SL\n税号（NIF）：B87171740\n网站域名：https://www.hotel-martorell.com/\n通讯地址：Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)\n电子邮箱：administracion@hotel-martorell.com\n电话：+34 937 745 160"],
      ["数据保护", "根据现行且适用的个人数据保护法规，我们在此告知您，您的数据将纳入由 EYE STAR SL（税号 B87171740，注册地址 Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)）所有的处理系统。以下提供所进行各项处理的相关信息。"],
      ["住宿在线预订管理", "目的：住宿在线预订的登记与管理。\n保存期限：3 年（依据 2003 年 7 月 3 日第 INT/1922/2003 号法令，关于酒店及类似住宿机构旅客登记簿与入住记录的规定）。\n合法依据：相关方的同意。\n基本数据：姓名、电话、税号（NIF）、电子邮箱、经济或保险数据。\n敏感数据：涉及未成年人的数据。\n数据转让：如有必要，您的数据将被提供给税务局、银行与储蓄机构、安全部队与执法机构及主管当局，以履行适用法规所规定的行政与安全义务。转让的合法依据为履行法律规定。"],
      ["商业活动（网页表单）", "目的：收集、登记与处理数据，以处理您的咨询和／或请求，以及用于广告与商业开发。\n保存期限：在所给予的同意持续有效期间，法律义务除外。\n合法依据：相关方的同意。\n基本数据：姓名、电子邮箱。"],
      ["网站用户管理", "目的：收集、登记与处理用户数据。\n保存期限：在所给予的同意持续有效期间，法律义务除外。\n合法依据：相关方的同意。\n基本数据：姓名、电子邮箱。"],
      ["Cookie 的安装", "目的：Cookie 的管理与安装。\n保存期限：在所给予的同意持续有效期间。\n合法依据：相关方的同意。\n基本数据：电子邮箱、IP 地址。"],
      ["邮件订阅（Newsletter）", "目的：管理邮件订阅，以进行相应的发送。\n保存期限：在所给予的同意持续有效期间。\n合法依据：相关方的同意。\n基本数据：姓名、电子邮箱。"],
      ["网页表单管理", "目的：处理您的咨询和／或请求。\n保存期限：在所给予的同意持续有效期间。\n合法依据：相关方的同意。\n基本数据：姓名、电子邮箱、IP 地址。"],
      ["相关方的权利", "您可行使对其个人数据的访问、更正、限制、删除、可携带及反对处理的权利，以及不受自动化决策（包括用户画像）约束的权利，并可撤回已给予的同意：\n• 访问权：获知您的数据是否被处理，如是，获知具体数据及该处理的法律信息。\n• 更正权：更正不准确或不完整的数据。\n• 限制权：在特定情形下限制处理目的。\n• 删除权：删除您的数据，但《通用数据保护条例》（GDPR）规定的例外除外。\n• 可携带权：以结构化、通用且可机器读取的格式获取您的数据，并将其传输给另一负责人。\n• 反对权：在规定情形下，拒绝处理您的数据或要求停止处理。\n• 不受自动化决策（包括用户画像）约束的权利。\n• 撤回同意权：可随时且免费撤回。"],
      ["权利的行使", "为行使上述权利，您可向 Avda. de la Industria 16, Edificio A, Local 207, 28760 Tres Cantos (Madrid)（收件人：EYE STAR SL）寄送书面申请，或发送电子邮件至 administracion@hotel-martorell.com。相关方须可靠地证明其身份；如对其身份存疑，可要求其补正申请。申请亦可由经正式确认并获授权的法定或自愿代理人提出。须具体说明拟行使的权利，并提供用于通知的地址及必要的证明文件。任何情况下均不会通过电话提供信息。"],
      ["向监管机构投诉", "如您认为某一行为可能构成对适用数据保护法规的违反，您有权向西班牙数据保护局提出投诉。"],
      ["安全措施", "EYE STAR SL 承诺根据所进行处理的风险等级，采取必要的技术与组织措施，以保障数据的完整性、保密性与可用性。"],
    ]},
    cookies: { title: "Cookie 政策", sections: [
      ["什么是 Cookie", "Cookie 是您浏览时存储在设备上的小文件，可记住偏好或衡量网站使用情况。"],
      ["我们使用的 Cookie", "运行所必需的技术性 Cookie（语言、管理会话及记住您的 Cookie 选择），以及仅在您同意后使用的 Google Analytics 4 分析 Cookie（_ga、_ga_*；最长 13 个月），IP 匿名化，用于了解网站使用情况并加以改进。"],
      ["第三方", "嵌入的 Google 地图与外部预订系统可能会安装其自身的 Cookie，受其各自政策约束。"],
      ["如何管理", "您可配置浏览器以阻止或删除 Cookie。这可能会影响网站的部分功能。"],
      ["管理您的同意", "首次访问时，您可以接受、拒绝或按类别设置 Cookie。您可随时通过页脚的“Cookie 设置”链接更改选择。若拒绝分析类 Cookie，Google Analytics 将以无 Cookie 模式（Consent Mode）运行，仅接收匿名信号。"],
    ]},
    updated: "最近更新",
  },
  consent: {
    eyebrow: "Cookie",
    title: "您的隐私，由您做主",
    text: "我们使用必要的第一方 Cookie；仅在您同意的情况下，才使用分析类 Cookie（Google Analytics）以了解网站使用情况并加以改进。您可随时通过页脚的“Cookie 设置”更改选择。",
    more: "Cookie 政策",
    acceptAll: "全部接受",
    reject: "拒绝",
    configure: "设置",
    save: "保存选择",
    close: "关闭",
    always: "始终启用",
    necessary: { t: "必要", d: "网站运行所必需：语言、安全性以及记住您的 Cookie 选择。" },
    analytics: { t: "分析", d: "Google Analytics（IP 匿名化），用于统计访问量并改进网站。若拒绝，仅发送无 Cookie 的匿名信号。" },
    marketing: { t: "营销", d: "用于衡量广告活动并个性化 Google 广告。目前我们不使用此类 Cookie。" },
  },
  notFound: { title: "未找到页面", text: "您所查找的页面不存在或已更改地址。", cta: "返回首页" },
  chat: {
    open: "酒店助手",
    close: "关闭",
    title: "酒店助手",
    subtitle: "全天候即时解答",
    intro: "您好，我是 Hotel Ciutat Martorell 的虚拟助手。欢迎咨询客房、早餐、交通、会议室或活动等问题。",
    placeholder: "请输入您的问题…",
    send: "发送",
    suggestions: ["早餐几点开始？", "从巴塞罗那怎么过来？", "有停车场吗？"],
    human: "想与真人沟通？",
    call: "致电",
    whatsapp: "WhatsApp",
    book: "预订",
    error: "目前无法回答。请致电",
    disclaimer: "自动助手，可能出错。如需预订，请使用“预订”按钮。",
  },
  admin: {
    googleLogin: "使用 Google 登录",
    or: "或",
    aiTranslate: "用 AI 从西班牙语翻译",
    login: "面板登录",
    email: "电子邮箱",
    password: "密码",
    enter: "登录",
    logout: "退出",
    panel: "内容面板",
    tabs: { nye: "跨年夜", stats: "统计", ai: "AI 助手", leads: "请求", content: "文本", rooms: "客房", meeting: "会议室", faqs: "常见问题", gallery: "图库", blog: "博客", survey: "可持续发展", settings: "酒店资料" },
    save: "保存",
    saved: "已保存",
    add: "添加",
    delete: "删除",
    status: { nuevo: "新", en_proceso: "处理中", cerrado: "已关闭" },
    noLeads: "暂无请求。",
    resend: "重新发送提醒",
    resendOk: "提醒已重新发送至",
    resendFail: "无法发送提醒",
    notifySent: "邮件提醒已发送",
    notifyFailed: "邮件提醒发送失败",
    notifyUnknown: "无发送记录",
  },
  common: {
    seeMore: "查看更多",
    bookNow: "立即预订",
    call: "致电酒店",
    placeholderNote: "临时照片",
  },
  pages: {
    rooms: {
      seoTitle: "马托雷利客房 · 21 m² 大床房与双床房",
      seoDesc: "舒适客房，配光纤 Wi-Fi、办公桌与自助早餐。双人间与双床间。直接预订享最优价格。",
      heroTitle: ["为真正的休憩", "而设计的客房"],
      heroText: "92 间客房，为商务与休闲旅客的极致休憩而设计。",
    },
    roomDetailSuffix: "客房",
    corporate: {
      seoTitle: "马托雷利的商务酒店与会议室",
      seoDesc: "企业协议价、3 间最多容纳 180 人的会议室，以及距 SEAT-CUPRA 与马托雷利工业区 5 分钟的住宿。24 小时内提供报价。",
      heroTitle: ["您在略夫雷加特走廊的", "运营基地"],
    },
    meetingRooms: {
      seoTitle: "马托雷利的会议与活动场地",
      seoDesc: "3 间自然采光、35 至 220 平方米的会议室，可容纳 12 至 180 人的会议、培训与大型会议。配视听设备、光纤与茶歇。",
      heroTitle: ["三间会议室，", "无限布置方式"],
    },
    events: {
      seoTitle: "马托雷利的婚礼、庆典与团体活动",
      heroTitle: ["重要的日子", "值得一个相称的场所"],
      stepsTitle: "三步到位，毫无烦恼",
    },
    restaurant: {
      seoTitle: "马托雷利的餐厅 · 地中海料理",
      heroTitle: ["地中海", "市集料理"],
    },
    location: {
      seoTitle: "位置 · 距巴塞罗那 30 分钟的马托雷利酒店",
      heroTitle: ["位于一切要事", "的中心"],
      distancesTitle: "距离与时间",
    },
    gallery: {
      seoDesc: "马托雷利四星级 Hotel Ciutat Martorell 的照片：双人房与双床房、浴室、会议室、宴会厅、My Bar 餐厅、公共区域及周边环境。",
      biosphereNote: "Hotel Ciutat Martorell 已获得 Biosphere 可持续旅游认证。欢迎在我们的官方主页直接查看我们在可持续发展方面的所有行动与承诺。",
    },
    blog: { seoDesc: "马托雷利、巴塞罗那与蒙塞拉特实用指南：如何乘火车或驾车前往、游览推荐、餐饮去处，以及面向商务旅客和家庭的贴士。" },
    faq: { eyebrow: "常见问题", home: "客人常问的问题", rooms: "关于客房", corporate: "关于会议与商务住宿", events: "关于婚礼、庆典与团队", restaurant: "关于餐厅" },
    biosphere: { seoTitle: "可持续发展 · Biosphere 认证" },
    contact: { hoursValue: "入住 15:00 · 退房 12:00" },
    seal: { sustainableTourism: "可持续旅游", certifiedBy: "认证机构", viewCert: "查看认证" },
    bookingCta: {
      eyebrow: "官方直订",
      rooms: { title: "官网直订，最优价格保证", text: "在官网直接预订可享最优价格，无中间商、无佣金。" },
      location: { title: "距巴塞罗那与蒙特塞拉特 30 分钟", text: "入住紧邻 Renfe 与 FGC 车站的酒店，机场 30 分钟可达。官网直订，最优价格保证。" },
    },
    blogPost: {
      sidebarTitle: "距火车站 100 米安睡",
      cta: {
        eyebrow: "官方直订",
        secondary: "索取报价",
        transport: { title: "距火车站 100 米安睡", text: "入住紧邻 Renfe 与 FGC 车站的酒店，30 分钟直达巴塞罗那。官网直订，最优价格保证。" },
        guides: { title: "探索马托雷利的理想大本营", text: "巴塞罗那、蒙特塞拉特与机场均 30 分钟可达。官方直订，开始规划您的假期。" },
        business: { title: "为您的企业提供住宿与会议室", text: "距工业区 5 分钟，配有会议室并提供企业协议价。欢迎向我们索取专属报价。" },
        default: { title: "预订您在马托雷利的住宿", text: "距巴塞罗那 30 分钟的四星级酒店。官网直订，最优价格保证。" },
      },
    },
    homeHeadings: {
      presentation: ["马托雷利四星级酒店。", "休憩、工作与庆典，", "距巴塞罗那 30 分钟。"],
      gastronomy: ["地中海市集料理，", "从容不迫"],
      extras: ["一场活动、一次会议，", "还是长期入住？"],
      heroRooms: "客房",
    },
  },
};

export default zh;
